import { EmployeeCreateRequestDto } from "src/dtos/user/request/employCreateRequestDto";
import { formatDate } from "src/utils/string/stringUtil";


export interface SYS3010_R01Dto extends EmployeeCreateRequestDto {
    inserted: boolean;
    isModified: boolean;
    empNm?: string;
    compNm?: string;
    orgNm?: string;
    hovered?: boolean;
	selected?: boolean;
}

/**
 * 기본 사용자 데이터
 * 새로운 사용자 생성 시 사용되는 기본값
 */
export const defaultSYS3010_R01Dto: SYS3010_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
    userId: "",
    userNm: "",
    orgCd: "",
    compCd: "",
    empNo: "",
    compAut: "N",
    costAut: "Y",
    approveAut: "Y",
    deleteAut: "Y",
    autGroupCd: "",
    lockSts: "N",
    password: "",
    passUpdate: formatDate(new Date()),
    menuAuth: "",
    bookMark: "",
    workplaceCd: "",
    remark: "",
    autGroupNm: "",
    menuAuthNm: "",
    detailAddress: "",
    inserted: false,
    isModified: false,
}